import React from 'react';
import { StyledUploadAndForm, LeftSection, RightSection } from './index.style';
import VoiceInfo from './VoiceInfo';
import AudioUploadSection from './AudioUploadSection';

const UploadAndForm = ({
  voiceInfo,
  errors,
  onVoiceInfoChange,
  disabled,
  onFileUpload,
  progress,
  onOpenTips,
  audios,
  onDelete,
  onPlay,
  playingAudioId,
  isPlaying,
  onAdjust,
  isLoadingAudios,
}) => (
  <StyledUploadAndForm>
    <LeftSection>
      <VoiceInfo
        voiceInfo={voiceInfo}
        errors={errors}
        onChange={onVoiceInfoChange}
        disabled={disabled}
      />
    </LeftSection>
    <RightSection>
      <AudioUploadSection
        onFileUpload={onFileUpload}
        progress={progress}
        onOpenTips={onOpenTips}
        audios={audios}
        onDelete={onDelete}
        onPlay={onPlay}
        playingAudioId={playingAudioId}
        isPlaying={isPlaying}
        onAdjust={onAdjust}
        isLoadingAudios={isLoadingAudios}
      />
    </RightSection>
  </StyledUploadAndForm>
);

export default UploadAndForm;
